import React from 'react'
import { Grid, GridCell, Text, View } from 'oio-react'
import pluralize from 'pluralize'
import { isDynamicOrganizationDomain } from 'config/constants/urls'
import { useOrganization, useSpaceList } from 'src/graphql/hooks'

const ProfileSpaceBlock = () => {
   const { organization } = useOrganization()
   const { spaceList } = useSpaceList()

   if (spaceList.items.length === 0) {
      return null
   }

   const handleSelectSpace = (space) => {
      if (isDynamicOrganizationDomain) {
         window.sessionStorage.setItem('ORGANIZATION_ID', space.id)
         window.location.assign('/')
      } else {
         window.open(`//${space.siteUrl}`, '_blank')
      }
   }

   return (
      <View
         float="left"
         width="100%"
         border="1px solid #eee[d-f]"
         padding="20px[d-f]"
         marginBottom="40px">
         <View paddingBottom="20px">
            <Text
               size="3"
               weight="medium"
               color="#111">
               Organizations
            </Text>
         </View>
         <Grid columns="1[a-b] 2[c] 1[d] 2[e] 3[f]" spacing="10px">
            {spaceList.items.map((space) => {
               const memberRole = space.roles.find(r => r.type === 'primary')

               return (
                  <GridCell key={space.id}>
                     <View
                        onClick={() => handleSelectSpace(space)}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        padding="10px 10px 0px 10px"
                        borderTop="1px solid #eee">
                        <View display="flex" alignItems="center">
                           <View
                              flex="0 0 auto"
                              width="30px"
                              height="30px"
                              backgroundColor="#eee"
                              backgroundImage={`url(${space.logoFavicon?.file.thumbnailUrlW60})`}
                              backgroundSize="cover"
                              backgroundPosition="center center"
                              borderRadius="5px"
                              marginRight="20px"
                              border={organization.id === space.id && '2px solid #aaa'}
                           />
                           <View>
                              <Text size="2" weight="medium" color="#222">
                                 {space.name}
                              </Text>
                              {memberRole?.numActiveUsers > 0 && (
                                 <Text size="1" color="#888">
                                    {pluralize('Members', memberRole.numActiveUsers, true)}
                                 </Text>
                              )}
                           </View>
                        </View>
                        {organization.id === space.id && (
                           <View
                              display="flex"
                              alignItems="center"
                              height="20px"
                              backgroundColor="#ddd"
                              padding="0px 10px"
                              borderRadius="15px"
                              margin="0px 10px">
                              <Text size="1" color="#444" weight="medium">
                                 Current
                              </Text>
                           </View>
                        )}
                     </View>
                  </GridCell>
               )
            })}
         </Grid>
      </View>
   )
}

export default ProfileSpaceBlock
